import RichText from "@app/_blocks/RichText";
import ReturnIcon from "@app/_icons/ReturnIcon/ReturnIcon";
import type { ProductPageInfoBlockFragment } from "@server/gql/graphql";
import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

export default function ProductPageReturnUspItem({
  className,
  usp,
  marketCode,
  locale,
  ...props
}: ComponentProps<"li"> & {
  usp: ProductPageInfoBlockFragment;
  marketCode: string;
  locale?: string;
}) {
  return (
    <li
      className={cn(
        "flex items-start gap-4 p-4 whitespace-break-spaces",
        className,
      )}
      {...props}
    >
      <ReturnIcon className="size-5 shrink-0 text-black" />
      <RichText
        className="not-prose"
        content={usp.content}
        market={marketCode}
        locale={locale}
      />
    </li>
  );
}
